import * as React from 'react';
import { Select } from '@grandvisionhq/forms';

const Oney = ({ options , labels , onChange  })=>/*#__PURE__*/ React.createElement(Select, {
        id: "oneyInstallments",
        name: "oneyInstallments",
        options: options,
        onChange: onChange,
        label: labels.title,
        placeholder: labels.placeholder,
        required: true
    })
;

export { Oney };
//# sourceMappingURL=Oney.js.map
